import { render, staticRenderFns } from "./RequesterItem.vue?vue&type=template&id=68579c85&scoped=true"
import script from "./RequesterItem.vue?vue&type=script&lang=js"
export * from "./RequesterItem.vue?vue&type=script&lang=js"
import style0 from "./RequesterItem.vue?vue&type=style&index=0&id=68579c85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68579c85",
  null
  
)

export default component.exports